import Col from "react-bootstrap/Col";
import { Button, Card, Form, Table } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import IconSvg from "../../../IconSvg";
import ScrollableCard from "../../../ScrollableCard";
import { ParseDate } from "../../../../../Helpers/DateHelper";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import ApiHelper from "../../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../../Helpers/EnumHelper";

const RequestHistory = ({ myHelpRequests }) => {
  const { t } = useTranslation();

  const [selectedImage, setSelectedImage] = useState();
  return (
    <Row>
      <Col>
        {myHelpRequests.map((req) => (
          <Card key={req.id} className="mb-4 shadow-sm">
            <Card.Header>
              <strong>#ID: {req.id}</strong>
            </Card.Header>
            <Card.Body>
              <Table bordered hover responsive className="mb-3">
                <tbody>
                  <tr>
                    <th>Fotoğraf</th>
                    <td className={"text-color-gray-light"}>
                      {req.imageName ? (
                        <Button className={"text-white"} size={"sm"} onClick={() => setSelectedImage(req.imageName)}>
                          Görüntüle
                        </Button>
                      ) : (
                        "Fotoğraf yok"
                      )}
                    </td>
                    <th>Oluşturma Tarihi</th>
                    <td>{new Date(req.creationDate).toLocaleString()}</td>
                  </tr>
                  <tr>
                    <th>Durum</th>
                    <td>
                      <Row>
                        <Col xs={"auto"}>
                          {req.isResolved ? (
                            <IconSvg icon={"tick-box"} width={30} height={30}></IconSvg>
                          ) : (
                            <IconSvg icon={"info-box"} width={30} height={30}></IconSvg>
                          )}
                        </Col>
                        <Col className={"ps-0 align-content-center"} xs={"auto"}>
                          {req.isResolved ? t("resolved") : t("workingOnIt")}
                        </Col>
                      </Row>
                    </td>

                    <th>Çözüm Tarihi</th>
                    <td>data yok</td>
                  </tr>
                </tbody>
              </Table>

              <Row>
                <Col xs={"auto"} className={"align-content-center"}>
                  <strong>Başlık:</strong>
                </Col>
                <Col>
                  <div className="text-24" style={{ whiteSpace: "pre-wrap" }}>
                    {req.title}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>Konu:</strong>
                  <div className="mt-2" style={{ whiteSpace: "pre-wrap" }}>
                    {req.subject}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
      </Col>
      <Modal
        show={selectedImage}
        onHide={() => {
          setSelectedImage(null);
        }}
      >
        <Image src={ApiHelper.cloudFrontURL + folderEnum.help + selectedImage} width={"100%"}></Image>
      </Modal>
    </Row>
  );
};
export default RequestHistory;
